import React, { useCallback } from 'react';
import { DatePicker as StyledDatePicker } from './DatePicker.styles';
import type { DatePickerProps as MantineDatePickerProps } from '@mantine/dates';

export type DateValue = Date | null;
export type DatesRangeValue = [DateValue, DateValue];

export interface DatePickerProps
  extends Pick<MantineDatePickerProps, 'maxDate' | 'minDate' | 'defaultDate'> {
  value: DatesRangeValue;
  onChange: (value: DatesRangeValue) => void;
  markedDates?: Date[];
  className?: string;
}

const DatePicker = React.forwardRef(
  (
    {
      value,
      onChange,
      markedDates,
      className,
      maxDate,
      minDate,
      defaultDate,
    }: DatePickerProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const markDates = useCallback(
      (date: Date) => {
        if (
          markedDates?.find(
            (markedDate) => markedDate.toDateString() === date.toDateString(),
          )
        ) {
          return {
            className: 'marked-date',
          };
        }
        return {};
      },
      [markedDates],
    );

    return (
      <StyledDatePicker
        className={className}
        value={value}
        onChange={onChange}
        ref={ref}
        type="range"
        allowSingleDateInRange
        getDayProps={markDates}
        minDate={minDate}
        maxDate={maxDate}
        defaultDate={defaultDate}
      />
    );
  },
);

DatePicker.displayName = 'DatePicker';
export default DatePicker;
